import { ENRICHMENT_CATEGORY_TYPE_PROFILE } from 'common-data-handling';
import React from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import Button from '../../../../../elements/Button/Button';
import Tabs from '../../../../../elements/Tabs/Tabs';
import OpenChatButton from './OpenChatButton';

function UserProfileTabs(props) {
    const { event, user, isMe, canBeInvited, inviteURL, onPokeUser } = props,
        i18n = useI18n();

    let optionLeft, optionRight;
    if (isMe) {
        optionRight = (
            <Button className="primary" href={['.', 'enrich', ENRICHMENT_CATEGORY_TYPE_PROFILE].join('/')}>
                {i18n['label.go.to.profile']}
            </Button>
        );
    } else {
        if (user.pref_available_for_chat && (event?.id || user.events_connected.length)) {
            optionLeft = <OpenChatButton className="primary" user={user} />;
        }
        if (canBeInvited) {
            optionRight = (
                <Button className="primary" href={inviteURL}>
                    {i18n['label.send.invitation']}
                </Button>
            );
        }
        //  else {
        //     // TODO: add option to ivite to Inscene App
        // }
    }

    let pokeButton;
    if (user.can_poke) {
        pokeButton = (
            <Button className="primary" onClick={onPokeUser}>
                {i18n['label.invite.me.to.netwerkapp']}
            </Button>
        );
    }

    return (
        <>
            {optionLeft || optionRight ? (
                <Tabs className="primary">
                    {optionLeft}
                    {optionRight}
                </Tabs>
            ) : null}
            {pokeButton ? <div className="content">{pokeButton}</div> : null}
        </>
    );
}

export default UserProfileTabs;
